import React from 'react';
import { string } from 'prop-types';

import cx from 'classnames';
import s from './PrintButton.css';


const PrintIcon = ({ className, width, height, iconTitle, id }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      aria-labelledby={id}
      viewBox="2178 15991 24.605 21.721">
      <title id={id}>{iconTitle}</title>
      <g id="Group_4936" data-name="Group 4936">
        <path d="M2190.69 15991h-10.354v7.162h13.313v-4.126a2.927 2.927 0 0 0-2.96-3.036z"/>
        <path d="M2200.343 15999.642h-20.007a2.294 2.294 0 0 0-2.336 2.336v6.306a2.294 2.294 0 0 0 2.336 2.336h.234a4.507 4.507 0 0 1 4.438-5.683h10.586a4.6 4.6 0 0 1 4.593 4.593 5.257 5.257 0 0 1-.156 1.09h.235a2.294 2.294 0 0 0 2.335-2.336v-6.306a2.23 2.23 0 0 0-2.257-2.336zm.234 2.725a.78.78 0 1 1 .78-.78.78.78 0 0 1-.78.78z"/>
        <path d="M2195.673 16006.337h-10.666a3.192 3.192 0 0 0 0 6.384h10.588a3.206 3.206 0 0 0 3.192-3.19 3.14 3.14 0 0 0-3.114-3.193z"/>
      </g>
    </svg>
  );
};

const PrintButton = ({ ...props }) => {
  const print = () => window.print();

  return (
    <section className={s.component}>
      <nav className={s.container}>
        <button
          type="button"
          onClick={print}
          className={cx(s.iconButton, s.hideForMobile)}
        >
          <PrintIcon
            className={s.icon}
            iconTitle="Print"
            id={`${props.id}__icon`}
            height="20px"
            width="27px"
          />
          Print
        </button>
      </nav>
    </section>
  );
};

PrintButton.propTypes = {
  id: string,
};

export default PrintButton;



// WEBPACK FOOTER //
// ./src/components/PrintButton/PrintButton.js